import React, { ReactElement, useContext, useEffect } from 'react'
import { ArtData } from '@/database/art'
import { Context } from '@/components/Context'
import ModalButtons from '@/components/ModalButtons'
import Offer from '@/components/boxes/Offer'
import Claim from '@/components/boxes/Claim'
import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import { crazyAmount, priceText, transferFeeText } from '@/utils/formatting'
import Box from '@/components/boxes/Box'
import LoadImageButtonOnDemand from '@/components/LoadImageButtonOnDemand'
import VotesTooltip from '@/components/tooltips/VotesTooltip'
import ClaimsReceivedTooltip from '@/components/tooltips/ClaimsReceivedTooltip'
import ClaimsMadeTooltip from '@/components/tooltips/ClaimsMadeTooltip'
import DetailsTabs from '@/components/market/DetailsTabs'
import { UpdateType } from '@/types/websocket'

const tabName = '#market'

const ModelMarketCardDetails = ({ artData, onClose }: { artData: ArtData; onClose: () => void }): ReactElement => {
    const { setActiveUpdates } = useContext(Context)

    useEffect(() => {
        setActiveUpdates([UpdateType.MARKETS, UpdateType.VOTES, UpdateType.PORTFOLIO])
    }, [])

    return (
        <div>
            {artData && (
                <div>
                    <div className="buttons-container">
                        <ModalButtons artData={artData} onClose={onClose} />
                    </div>
                    <div className="p-copy">
                        <Offer artData={artData} />
                        <Claim artData={artData} />
                    </div>
                    {artData && (
                        <div>
                            <div className="header-container center">
                                <div key={artData.art.id} className="artwork-box ">
                                    <div className="header-container center bottom">
                                        <Box
                                            caption={'NFT'}
                                            text={'#' + (artData.tokenId ? artData.tokenId : artData.art.id)}
                                        />
                                        <Box caption={'Title'} text={artData.art.title} />
                                    </div>
                                    <div className="header-container bottom">
                                        <Box caption={'Description'} text={artData.art.prompt} />
                                    </div>
                                    {artData.highestOffer && (
                                        <div className="header-container bottom">
                                            <Box
                                                caption={'Highest Offer'}
                                                text={crazyAmount(artData.highestOffer, `white large-bold`)}
                                                textValue={artData.highestOffer}
                                                styleCaption={'gradient-text bold large-bold '}
                                                styleText={'center nav__voted-amount large'}
                                            />
                                        </div>
                                    )}
                                    <LoadImageButtonOnDemand artData={artData} />
                                    <div className={'header-container'}>
                                        <div id={'votes' + artData.art.id} className="p-copy">
                                            <Box
                                                caption={'Claim Power'}
                                                text={artData.claimPower.toFixed(2)}
                                                styleText={'center'}
                                            />
                                        </div>
                                        <div id={'claims-made' + artData.art.id} className="p-copy">
                                            <Box
                                                caption={'Claims Made'}
                                                id={'claims-made' + artData.art.id}
                                                styleText={'center'}
                                                text={artData.totalClaims.toFixed(2)}
                                            />
                                        </div>
                                        <div id={'claims-received' + artData.art.id} className="p-copy">
                                            <Box
                                                caption={'Claims Received'}
                                                id={'claims-received' + artData.art.id}
                                                styleText={'center'}
                                                text={artData.totalClaimed.toFixed(2)}
                                            />
                                        </div>
                                    </div>
                                    <div className="header-container bottom">
                                        <Box
                                            caption={'Sale Price'}
                                            styleText={'center'}
                                            text={priceText(artData)}
                                            textValue={artData?.art.price}
                                            triggerAnimation={false}
                                        />
                                        <Box
                                            caption={'Transfer Fee'}
                                            styleText={'center'}
                                            text={transferFeeText(artData)}
                                            textValue={artData?.art.transferFee}
                                            triggerAnimation={false}
                                        />
                                    </div>
                                    <VotesTooltip artData={artData} />
                                    <ClaimsMadeTooltip artData={artData} />
                                    <ClaimsReceivedTooltip artData={artData} />
                                </div>
                            </div>
                            <DetailsTabs artData={artData} tabName={tabName} />
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}

ModelMarketCardDetails.whyDidYouRender = true

export default ModelMarketCardDetails
